import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-10 0 310 300"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M38 112q-1-38 22.5-68.5t61-40T194 9t54 48.5 13.5 71.5-33.5 64q-6 6-8 12l-15 33q-2 6-8 6 4 0 6.5 2.5t2.5 6.5-2.5 6.5-6.5 2.5q4 0 6.5 3t2.5 7-2.5 6.5-6.5 2.5l-4 9q-3 4-7.5 7t-9.5 3h-52q-5 0-9.5-3t-7.5-7l-4-9q-4 0-6.5-2.5T94 272t2.5-7 6.5-3q-4 0-6.5-2.5T94 253t2.5-6.5 6.5-2.5q-6 0-8-6l-15-33q-3-7-8-12-17-16-26-37t-9-44zm112-93q-29 0-52.5 16T63 77.5 58 132t27 48q8 8 12 17l12 28h82l12-28q4-9 12-17 21-20 27-48t-5-54.5T202.5 35 150 19"
    }, null, -1)
  ])))
}
export default { render: render }